import AppConfig from "util/AppConfig";
export const DEFAULT_PRODUCT_NAME = "Graylog";
const useProductName = () => {
  var _a, _b, _c, _d;
  return (_d = (_c = (_b = (_a = AppConfig).branding) == null ? void 0 : _b.call(_a)) == null ? void 0 : _c.product_name) != null ? _d : DEFAULT_PRODUCT_NAME;
};
export default useProductName;
